import { render } from "./PreviewDialog.vue?vue&type=template&id=a4cc84a0&scoped=true"
import script from "./PreviewDialog.vue?vue&type=script&lang=js"
export * from "./PreviewDialog.vue?vue&type=script&lang=js"

import "./PreviewDialog.vue?vue&type=style&index=0&id=a4cc84a0&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4cc84a0"]])

export default __exports__